import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { INotificationFeed } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = `${BASE_API_URL}notification-feed`;

/**
 * Local fork of @curbnturf/user's NotificationFeedService — trimmed to plain
 * HttpClient (the real class's only curbnturf-specific dependency,
 * CachedHttpClient, always resolved to a plain pass-through under
 * the old LocalCachedHttpClient override anyway). Full method set — all 3 are used.
 */
@Injectable({ providedIn: 'root' })
export class NotificationFeedApiService {
  private readonly http = inject(HttpClient);

  fetchAll(): Observable<INotificationFeed[]> {
    return this.http.get<INotificationFeed[]>(API_URL);
  }

  markRead(id: number): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${API_URL}/${id}/read`, null);
  }

  markAllRead(): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${API_URL}/mark-all-read`, null);
  }
}
